const formatCashOptions = {
  display: 'long'
}

const notation = {
  long: {
    k: 'ribu',
    m: 'juta',
    b: 'miliar',
    t: 'triliun'
  },

  short: {
    k: 'rb',
    m: 'jt',
    b: 'M',
    t: 'T'
  }
}

function formatter (n, { display } = formatCashOptions) {
  if (n < 1e3) return n
  if (n >= 1e3 && n < 1e6) return +(n / 1e3) + ' ' + notation[display].k
  if (n >= 1e6 && n < 1e9) return +(n / 1e6) + ' ' + notation[display].m
  if (n >= 1e9 && n < 1e12) return +(n / 1e9) + ' ' + notation[display].b
  if (n >= 1e12) return +(n / 1e12) + ' ' + notation[display].t
}

/**
 * Format number to human readable format (100 juta/miliar).
 * Currently only supported in Indonesia locale.
 *
 * @param {number} number A numeric value to format
 * @param {Object} options Format options
 * @param {string} [options.display] Display mode of the formatted number (short/long)
 * @returns {string} Formatted number
 */
function formatCash (number, options = formatCashOptions) {
  let formatted
  if (number < 0) {
    formatted = '-' + formatter(-1 * number, options)
  } else {
    formatted = formatter(number, options)
  }
  return formatted
}

export default formatCash
